
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'TextInput',

	props: {
		label: { type: String, default: '' },
		password: { type: Boolean, default: false },
		text: { type: String, default: '' },
		center: { type: Boolean, default: false }
	},

	setup (props, { emit }) {
		function onInput (e: any) {
			emit('update:text', e.target.value)
		}
		return {
			onInput
		}
	}

})
